export enum RecipientType {
  SUBFLEET = 'Subflota',
  PLATE = 'Matrícula',
  SC_LIST = 'Listado SC',
  SC_GROUP = 'Grupo SC',
}

export enum GroupSC {
  SCWB = 'SC WB',
  SCNB = 'SC NB',
  SCLEVEL = 'SC LEVEL',
}

export const recipientTypeLabels = {
  [RecipientType.SUBFLEET]: 'messages.mailbox.recipientTypes.subfleet.option',
  [RecipientType.PLATE]: 'messages.mailbox.recipientTypes.plate.option',
  [RecipientType.SC_LIST]: 'messages.mailbox.recipientTypes.scList.option',
  [RecipientType.SC_GROUP]: 'messages.mailbox.recipientTypes.scGroup.option',
};

export const GroupSCLabels = {
  [GroupSC.SCWB]: 'messages.mailbox.recipientTypes.scGroup.group.SCWB',
  [GroupSC.SCNB]: 'messages.mailbox.recipientTypes.scGroup.group.SCNB',
  [GroupSC.SCLEVEL]: 'messages.mailbox.recipientTypes.scGroup.group.SCLEVEL',
};
